import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Router } from '../../routes';
import {
  ProfileLayout,
  Layout,
  Header,
  Footer,
  LoginModal,
  SignupModal,
  GhostTicket,
} from '../index';

import { ProfileContainer, ProfileContent } from '../ProfileLayout/styles';

const mapStateToProps = state => ({
  userData: state.user.userData,
});
@connect(mapStateToProps)
class CheckAuth extends Component {
  static propTypes = {
    children: PropTypes.node,
    redirect: PropTypes.string,
    userData: PropTypes.instanceOf(Object),
    layoutHeading: PropTypes.string,
    ProfileLayoutHeading: PropTypes.string,
    confirmation: PropTypes.bool,
    type: PropTypes.oneOf(['login', 'signup']),
    onClick: PropTypes.func,
  };

  static defaultProps = {
    type: 'login',
  };

  componentDidMount() {
    const { redirectIfNeed } = this;
    redirectIfNeed();
  }

  redirectIfNeed = () => {
    const { userData, redirect } = this.props;
    if (!userData || !redirect) {
      return;
    }

    try {
      const urlPlace = (Router.query && Router.query.fromPage) || redirect;
      Router.pushRoute(urlPlace);
    } catch (err) {
      // we in server side and should redirect in componentDidMount
    }
  };

  render() {
    const { redirectIfNeed } = this;
    const {
      userData,
      layoutHeading,
      ProfileLayoutHeading,
      children,
      type,
      confirmation,
      onClick,
    } = this.props;
    redirectIfNeed();
    const modalByTypeMapping = {
      login: LoginModal,
      signup: SignupModal,
    };

    const Modal = modalByTypeMapping[type] || modalByTypeMapping.login;

    let body = (userData && children) || <GhostTicket id={456785} />;

    if (ProfileLayoutHeading) {
      body = (
        <ProfileLayout onClick={onClick} heading={ProfileLayoutHeading} isInnerPage loggedIn={!!userData}>
          {body}
        </ProfileLayout>
      );
    } else if (confirmation) {
      body;
    } else {
      body = (
        <ProfileContainer>
          <ProfileContent>{body}</ProfileContent>
        </ProfileContainer>
      );
    }

    return (
      <Layout heading={[layoutHeading, 'Dayaxe.com'].filter(Boolean).join(' | ')}>
        {!userData && <Modal isClosable={false} />}
        <Header isInnerPage fixed />
        {body}
        <Footer isInnerPage />
      </Layout>
    );
  }
}

export default CheckAuth;
